// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  background-color: #d9d9d9;
  border-radius: 30px;
  border: 0px solid rgba(128, 128, 128, 0);
}

.toggle::after {
  content: '';
  position: absolute;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: rgb(255, 255, 255);

  left: 0px;
  transition: all 0.5s;
}

.checkbox:checked + .toggle::after {
  transform: translateX(26px);
}

.checkbox:checked + .toggle {
  background-color: #b7d423;
}

.checkbox {
  display: none;
}
@media screen and (max-width: 770px) {
  .toggle {
    width: 40px;
    height: 21px;
  }
  .toggle::after {
    width: 21px;
    height: 21px;
  }
  .checkbox:checked + .toggle::after {
    transform: translateX(21px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Switch/switch.styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;;EAEpC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n  background-color: #d9d9d9;\n  border-radius: 30px;\n  border: 0px solid rgba(128, 128, 128, 0);\n}\n\n.toggle::after {\n  content: '';\n  position: absolute;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background-color: rgb(255, 255, 255);\n\n  left: 0px;\n  transition: all 0.5s;\n}\n\n.checkbox:checked + .toggle::after {\n  transform: translateX(26px);\n}\n\n.checkbox:checked + .toggle {\n  background-color: #b7d423;\n}\n\n.checkbox {\n  display: none;\n}\n@media screen and (max-width: 770px) {\n  .toggle {\n    width: 40px;\n    height: 21px;\n  }\n  .toggle::after {\n    width: 21px;\n    height: 21px;\n  }\n  .checkbox:checked + .toggle::after {\n    transform: translateX(21px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
